import { noMeetingResponseRequired } from './MeetingRequestNoResponseButton.locstring.json';
import loc from 'owa-localize';
import MeetingActionButton from './MeetingActionButton';
import deleteMeetingMessage from '../actions/deleteMeetingMessage';
import { MeetingMessageActionType } from '../utils/MeetingMessageActionType';
import { observer } from 'mobx-react-lite';
import { ControlIcons } from 'owa-control-icons';
import MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';

import * as React from 'react';

export interface MeetingRequestNoResponseButtonProperties {
    item: MeetingRequestMessageType;
    logAction: (interactionType: MeetingMessageActionType, propertyNames?: string[]) => void;
}

export default observer(function MeetingRequestNoResponseButton(
    props: MeetingRequestNoResponseButtonProperties
) {
    const { item, logAction } = props;

    const onClick = React.useCallback(() => {
        logAction('NoResponseClicked');
        deleteMeetingMessage(item, true);
    }, [item, logAction]);

    return (
        <MeetingActionButton
            text={loc(noMeetingResponseRequired)}
            onClick={onClick}
            iconProps={{ iconName: ControlIcons.EventInfo }}
            secondary={true}
        />
    );
});
